import React from 'react';

function Footer() {
  return (
    <footer id="footer">
      <div className="containerr">
        <div className="copyright">
          &copy; Copyright <strong><span></span></strong>. All Rights Reserved. 
        </div>
       
      </div>
    </footer>
  );
}

export default Footer;
